'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var reactUtils = require('@chakra-ui/react-utils');
var utils = require('@chakra-ui/utils');
var React = require('react');
var CardColumnWrapper = require('../CardColumnWrapper/CardColumnWrapper.js');
require('../CardColumnWrapper/CardColumnWrapperImageWrap.js');
require('../CardColumnWrapper/CardColumnWrapperImage.js');
require('../CardColumnWrapper/CardColumnWrapperContent.js');
var HighlightCardErrorImage = require('./HighlightCardErrorImage.svg.js');
var HighlightCardInfoImage = require('./HighlightCardInfoImage.png.js');
var HighlightCardPartnerImage = require('./HighlightCardPartnerImage.svg.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var HIGHLIGHT_CARD_STATUSES = {
  info: {
    image: HighlightCardInfoImage["default"],
    colorScheme: 'yellow',
    isOverflowing: true,
    imageWidth: '130px'
  },
  partner: {
    image: HighlightCardPartnerImage["default"],
    colorScheme: 'blue',
    isOverflowing: false,
    imageWidth: '40px'
  },
  error: {
    image: HighlightCardErrorImage["default"],
    colorScheme: 'red',
    isOverflowing: true,
    imageWidth: '130px'
  }
};
var _createContext = reactUtils.createContext({
    name: 'HighlightCardContext',
    errorMessage: 'useHighlightCardContext: `context` is undefined. Seems you forgot to wrap HighlightCard components in `<HighlightCard />`.'
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  HighlightCardProvider = _createContext2[0],
  useHighlightCardContext = _createContext2[1];
/**
 * Highlighted Card
 *
 * Component that renders a "highlighted" card with an image on the left in breakpoints md and larger.
 */
var HighlightCard = react.forwardRef(function (props, ref) {
  var _props$colorScheme, _HIGHLIGHT_CARD_STATU, _styles$card, _styles$card2, _styles$card3, _styles$card4;
  var _omitThemingProps = react.omitThemingProps(props),
    children = _omitThemingProps.children,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var status = (props === null || props === void 0 ? void 0 : props.status) || 'info';
  var colorScheme = (_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : (_HIGHLIGHT_CARD_STATU = HIGHLIGHT_CARD_STATUSES[status]) === null || _HIGHLIGHT_CARD_STATU === void 0 ? void 0 : _HIGHLIGHT_CARD_STATU.colorScheme;
  var styles = react.useMultiStyleConfig('HighlightCard', _objectSpread(_objectSpread({}, props), {}, {
    status: status,
    colorScheme: colorScheme
  }));
  return /*#__PURE__*/React__default["default"].createElement(HighlightCardProvider, {
    value: {
      status: status
    }
  }, /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, rest, {
    className: utils.cx('chakra-highlight-card', props.className),
    __css: styles.card
  }), /*#__PURE__*/React__default["default"].createElement(CardColumnWrapper.CardColumnWrapper, {
    imageWidth: HIGHLIGHT_CARD_STATUSES[status].imageWidth,
    isOverflowing: HIGHLIGHT_CARD_STATUSES[status].isOverflowing,
    spacingBottom: ((_styles$card = styles.card) === null || _styles$card === void 0 ? void 0 : _styles$card.pb) || ((_styles$card2 = styles.card) === null || _styles$card2 === void 0 ? void 0 : _styles$card2.py),
    spacingLeft: ((_styles$card3 = styles.card) === null || _styles$card3 === void 0 ? void 0 : _styles$card3.pl) || ((_styles$card4 = styles.card) === null || _styles$card4 === void 0 ? void 0 : _styles$card4.px)
  }, children))));
});
HighlightCard.displayName = 'HighlightCard';
exports.HIGHLIGHT_CARD_STATUSES = HIGHLIGHT_CARD_STATUSES;
exports.HighlightCard = HighlightCard;
exports.HighlightCardProvider = HighlightCardProvider;
exports.useHighlightCardContext = useHighlightCardContext;